import { TextOverflowTooltip } from '@ipfabric/ui-components/Tooltip/TextOverflowTooltip';
import classNames from 'classnames';
import { ButtonAsA } from 'components/Button/ButtonAsA';
import type {
  EvalTestNode,
  SecuritySchemaNodeComponentProps,
} from 'components/SecuritySchema/model/SecuritySchemaNode';
import { navigateToRuleChain } from 'components/SecuritySchema/model/commands/navigateToRuleChain';
import { renderTestNodeMetaInfo } from 'components/SecuritySchema/nodeComponents/renderTestNodeMetaInfo';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

export const CEvalTestNode: FC<
  SecuritySchemaNodeComponentProps<EvalTestNode>
> = ({ node, context }) => {
  const msg = useLocale();
  const msgTest = msg.securitySchema.test;
  return (
    <div
      className={classNames(
        'security-tree-node security-tree-node--test-leaf',
        context.highlightedSubtree && 'security-tree-node--highlighted',
      )}
    >
      {renderTestNodeMetaInfo(node, msg)}
      <TextOverflowTooltip as='p'>
        {msgTest.eval.chainType[node.chainType]}
        {': '}
        <ButtonAsA
          onClick={() => {
            context.dispatch(navigateToRuleChain, {
              chainName: node.chainName,
              securityType: node.chainType,
              treeScrollContainer: context.treeScrollContainerRef.current,
            });
          }}
        >
          {node.chainName}
        </ButtonAsA>
      </TextOverflowTooltip>
      <p>
        <span
          className={classNames(
            'badge badge-inline text-uppercase',
            {
              failing: 'badge-danged',
              passing: 'badge-success',
            }[node.checkType],
          )}
        >
          {msgTest.eval.checkType[node.checkType]}
        </span>
      </p>
    </div>
  );
};
